import type { FormDataAdapter } from "$lib/util"
import { PatchBuilder } from "$lib/util/model-adapters/patch.ts"
import {
  EMPLOYMENT_STATUSES,
  type CustomerSuitability,
} from "@tastyworks/tastyworks-api"
import { object, string, type InferType } from "yup"

export const employmentStatusSchema = object({
  employmentStatus: string()
    .oneOf(Object.values(EMPLOYMENT_STATUSES))
    .required(),
})

export const jobDetailsSchema = object({
  employerName: string().required(),
  occupation: string().required(),
  jobTitle: string().required(),
})

export const employmentInfoSchema = object({
  employmentStatus: employmentStatusSchema,
  jobDetails: jobDetailsSchema,
})

type EmploymentInfoData = InferType<typeof employmentInfoSchema>

export const employmentStatusAdapter: FormDataAdapter<
  CustomerSuitability,
  EmploymentInfoData["employmentStatus"]
> = {
  toForm: (customerSuitability, employmentStatus) => {
    employmentStatus.employmentStatus =
      customerSuitability.employmentStatus ?? undefined

    return employmentStatus
  },
  toModel: (employmentStatus, customerSuitability) => {
    customerSuitability.employmentStatus = employmentStatus.employmentStatus
    return customerSuitability
  },
  toPatch: (employmentStatus) =>
    new PatchBuilder<CustomerSuitability>()
      .string("employmentStatus", employmentStatus.employmentStatus)
      .build(),
}

export const jobDetailsAdapter: FormDataAdapter<
  CustomerSuitability,
  EmploymentInfoData["jobDetails"]
> = {
  toForm: (customerSuitability, jobDetails) => {
    jobDetails.employerName = customerSuitability.employerName
    jobDetails.occupation = customerSuitability.occupation
    jobDetails.jobTitle = customerSuitability.jobTitle

    return jobDetails
  },
  toModel: (jobDetails, customerSuitability) => {
    customerSuitability.employerName = jobDetails.employerName
    customerSuitability.occupation = jobDetails.occupation
    customerSuitability.jobTitle = jobDetails.jobTitle
    return customerSuitability
  },
  toPatch: (jobDetails) =>
    new PatchBuilder<CustomerSuitability>()
      .string("employerName", jobDetails.employerName)
      .string("occupation", jobDetails.occupation)
      .string("jobTitle", jobDetails.jobTitle)
      .build(),
}
